export const FILTER_NONE = '__none__' as const;
export const FILTER_ALL = '__all__' as const;
